
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reveal } from './Reveal';

export const CustomProcess: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      id: "01",
      title: t('architecture.process.steps.01.title'),
      subtitle: t('architecture.process.steps.01.subtitle'),
      desc: t('architecture.process.steps.01.desc'),
      points: t('architecture.process.steps.01.points', { returnObjects: true }) as string[]
    },
    {
      id: "02",
      title: t('architecture.process.steps.02.title'),
      subtitle: t('architecture.process.steps.02.subtitle'),
      desc: t('architecture.process.steps.02.desc'),
      points: t('architecture.process.steps.02.points', { returnObjects: true }) as string[]
    },
    {
      id: "03",
      title: t('architecture.process.steps.03.title'),
      subtitle: t('architecture.process.steps.03.subtitle'),
      desc: t('architecture.process.steps.03.desc'),
      points: t('architecture.process.steps.03.points', { returnObjects: true }) as string[]
    },
    {
      id: "04",
      title: t('architecture.process.steps.04.title'),
      subtitle: t('architecture.process.steps.04.subtitle'),
      desc: t('architecture.process.steps.04.desc'),
      points: t('architecture.process.steps.04.points', { returnObjects: true }) as string[]
    }
  ];

  return (
    <section className="py-32 bg-gray-50 relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <Reveal>
          <div className="flex flex-col md:flex-row justify-between items-end mb-32 border-b border-gray-200 pb-8">
            <h2 className="text-5xl md:text-7xl font-bold text-gray-900 tracking-tighter leading-none">
              {t('architecture.process.title_line1')}<br />{t('architecture.process.title_line2')}
            </h2>
            <div className="text-right mt-8 md:mt-0">
              <p className="text-gray-500 text-lg max-w-md">
                {t('architecture.process.subtitle')}
              </p>
            </div>
          </div>
        </Reveal>

        <div className="relative">
          {/* Central Line */}
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-gray-300 -translate-x-1/2"></div>

          <div className="space-y-32">
            {steps.map((step, index) => (
              <Reveal key={step.id} delay={index * 0.1}>
                <div className={`flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-0 ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}>

                  {/* Content Side */}
                  <div className={`md:w-1/2 ${index % 2 !== 0 ? 'md:pl-24' : 'md:pr-24'} pl-16 w-full`}>
                    <div className="relative">
                      <span className="text-xs font-bold uppercase tracking-widest text-clever-teal mb-2 block">{step.subtitle}</span>
                      <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                      <p className="text-gray-500 leading-relaxed mb-6">{step.desc}</p>

                      {/* Bullet Points as Tags */}
                      <div className="flex flex-wrap gap-2">
                        {step.points.map((pt, idx) => (
                          <span key={idx} className="px-2 py-1 bg-white text-gray-600 text-[10px] font-bold uppercase tracking-wider border border-gray-200">
                            {pt}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Central Dot */}
                  <div className="absolute left-[19px] md:left-1/2 -translate-x-1/2 flex items-center justify-center">
                    <div className="w-3 h-3 rounded-full bg-clever-teal ring-8 ring-gray-50 z-10"></div>
                  </div>

                  {/* Empty Side */}
                  <div className="hidden md:block md:w-1/2" />

                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
